

export const COLORS = ['1F6EEF', 'FF7D00', 'F53F3F', '0FC6C2', 'F7BA1D', '722ED1', 'FADB1B', '9FDB1C', 'D91BD9', 'F5319D']
